import { Component, OnInit } from '@angular/core';
import { AngazovanjeRoResenje } from './angazovanje-ro-resenje';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-angazovanje-ro-resenje-modal-update',
  templateUrl: './angazovanje-ro-resenje-modal-update.component.html'
})
export class AngazovanjeRoResenjeModalUpdateComponent
extends BaseModalUpdateComponent<AngazovanjeRoResenje>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<AngazovanjeRoResenje>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
